import userApi from '@/api/user';

const state = {
  userProfile: {},
  workUnits: [], // 授权的工作单元即站点
};
const getters = {};
const mutations = {
  userRequest(userState, userProfile) {
    const myState = userState;
    myState.userProfile = userProfile;
  },
  getWorkUnits(userState, workUnits) {
    const myState = userState;
    myState.workUnits = workUnits;
  },
  removeUserProfile(userState) {
    const myState = userState;
    myState.userProfile = {};
  },
  removeWorkUnits(userState) {
    const myState = userState;
    myState.workUnits = [];
  },
};
const actions = {
  userRequest({ commit }, userProfile) {
    // 信息本地存储
    localStorage.setItem('userProfile', JSON.stringify(userProfile));
    commit('userRequest', userProfile);
  },
  getWorkUnits({ commit }) {
    return new Promise((resolve, reject) => {
      userApi.getWorkUnits().then((res) => {
        if (res.code === 200) {
          const workUnits = res.data;
          // 信息本地存储
          localStorage.setItem('workUnits', JSON.stringify(workUnits));
          commit('getWorkUnits', workUnits);
          resolve(workUnits);
        }
        return new Error(res.msg);
      }).catch((err) => {
        reject(err);
      });
    })
      .then((workUnits) => {
      // 更新车站状态
        const workUnitStatus = new Array(workUnits.length);
        workUnitStatus.fill(0);
        const promiseList = [];
        for (let i = 0; i < workUnits.length; i++) {
          const workUnit = workUnits[i];
          const { workUnitId } = workUnit;
          const index = i;
          const workUnitPromise = userApi.getWorkUnitStatus(workUnitId).then((res) => {
            if (res.code == 200) {
              workUnitStatus[index] = res.data;
            }
          });
          promiseList.push(workUnitPromise);
        }

        Promise.allSettled(promiseList).then((res) => {
          for (let i = 0; i < workUnits.length; i++) {
            workUnits[i].status = workUnitStatus[i];
          }
          localStorage.setItem('workUnits', JSON.stringify(workUnits));
          commit('getWorkUnits', workUnits);
        });
      });
  },
  removeUserProfile({ commit }) {
    // 清除本地信息
    localStorage.removeItem('userProfile');
    commit('removeUserProfile');
  },
  removeWorkUnits({ commit }) {
    // 清除本地信息
    localStorage.removeItem('workUnits');
    commit('removeWorkUnits');
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
